import { useNavigate } from "react-router-dom";
import { AlertTriangle, CreditCard } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSubscription } from "@/contexts/SubscriptionContext";

export const PaymentFailedBanner = () => {
  const navigate = useNavigate();
  const { subscriptionStatus, openCustomerPortal } = useSubscription();

  if (subscriptionStatus === 'sponsored' || (subscriptionStatus !== 'past_due' && subscriptionStatus !== 'unpaid')) {
    return null;
  }

  const handleUpdatePayment = async () => {
    try {
      const portalUrl = await openCustomerPortal();
      window.open(portalUrl, '_blank');
    } catch (error) {
      console.error("Failed to open customer portal:", error);
      navigate('/seller/manage-subscription');
    }
  };

  return (
    <div className="bg-gradient-to-r from-destructive to-destructive/90 text-destructive-foreground shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex items-start gap-3 flex-1">
            <AlertTriangle className="h-6 w-6 flex-shrink-0 mt-0.5" />
            <div>
              <h3 className="font-semibold text-lg mb-1">
                Payment Failed
              </h3>
              <p className="text-sm opacity-95">
                We couldn't process your payment. Please update your payment method within 7 days to avoid service interruption.
              </p>
            </div>
          </div>
          <Button
            onClick={handleUpdatePayment}
            size="lg"
            variant="secondary"
            className="whitespace-nowrap gap-2"
          >
            <CreditCard className="h-4 w-4" />
            Update Payment Method
          </Button>
        </div>
      </div>
    </div>
  );
};
